import { render, staticRenderFns } from "./PreguntasRespuestasProcesoIntegracion.vue?vue&type=template&id=55ed4442"
import script from "./PreguntasRespuestasProcesoIntegracion.vue?vue&type=script&lang=js"
export * from "./PreguntasRespuestasProcesoIntegracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports